import React from 'react'
import Footer from '../Footer'
import Uml4 from '../Uml4'

function Umass4() {
    window.scrollTo(0,0);
    return (
        <div>
            <Uml4/>
            <Footer/>
        </div>
    )
}

export default Umass4
